import styled from 'styled-components';

import variables from '../../../styles/variables';
import Link from '../../UI/Link/Link';
import { KioskProps } from '../../../types';

export const VariantContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 2rem 0;

  @media screen and (max-width: 640px) {
    width: 100%;
    padding: 1rem 0;
  }
`;

export const VariantDetailsWrapper = styled.div`
  display: grid;
  grid-template-columns: minmax(200px, 1fr) minmax(200px, 1fr);
  gap: 14px 21px;

  @media screen and (max-width: 450px) {
    grid-template-columns: 1fr;
  }
`;

export const Details = styled.button<{ selected: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  background: none;
  text-align: left;
  font-size: 14px;
  box-shadow: 0 0 0
    ${({ selected }) => (selected ? '2px #EE2E24' : '1px  #979797')};
  border-radius: 5px;
  border: 0;
  padding: 10px 15px;
  min-height: 48px;
  justify-content: space-between;
  cursor: ${({ selected }) => (selected ? 'auto' : 'pointer')};
`;

export const VariantName = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: ${variables.colorBlack};
  word-break: break-word;
`;

export const VariantPrice = styled.div`
  font-weight: 300;
  font-size: 12px;
  line-height: 13.4px;
  color: ${variables.colorBlack};
`;

export const Manufacturer = styled.div`
  width: 100%;
  text-align: center;
  font-size: 30px;
  font-weight: 600;
  line-height: 34px;
  text-align: left;
  margin-bottom: 4px;
  word-break: break-word;

  @media screen and (max-width: 1024px) {
    display: none;
  }
`;

export const Headline = styled.h1`
  width: 100%;
  color: ${variables.colorBlack};
  text-transform: none;
  margin-bottom: 10px;
  font-size: 30px;
  line-height: 34px;
  font-weight: 400;
  word-break: break-word;

  @media screen and (max-width: 1024px) {
    display: none;
  }
`;

export const ProductSku = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  max-width: 100%;
  width: 100%;
  margin-bottom: 32px;

  @media screen and (max-width: 1024px) {
    display: none;
  }
`;

export const ProductSkuItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 12px;
  line-height: 14px;
  padding-right: 0.5rem;

  strong {
    padding-right: 0.25rem;
  }
`;

export const ProductSkuBrand = styled(Link)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 12px;
  line-height: 14px;
  font-size: 12px;
  line-height: 14px;
  color: ${variables.colorRed};
  text-decoration: underline;
  margin-bottom: 0;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
`;

export const Text = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  margin-bottom: 12px;

  &.option {
    line-height: 30px;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 30.5px;
  padding-bottom: 18px;
`;

export const PromoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Price = styled.div`
  font-weight: 600;
  font-size: 26px;
  line-height: 29.04px;
  margin-right: 23px;
`;

export const PcoPoints = styled.div<KioskProps>`
  display: flex;
  flex-direction: column;
  color: ${variables.colorRed};
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  position: relative;
  span {
    font-weight: 400;
    font-size: ${({ isKiosk }) => isKiosk ? variables.defaultMinFontSizeKiosk : 9}px;
    line-height: 8px;
  }
  div {
    sup {
      top: -0.25rem;
      font-size: 10px;
      font-weight: normal;
    }
  }
  &:after {
    position: absolute;
    right: -1.3em;
    top: 0.8em;
    width: 1.1em;
    height: 1.1em;
    content: '';
    background-image: url('/pts.svg');
    background-size: 1.1em;
    background-repeat: no-repeat;
  }
`;

export const InventoryWrapper = styled.div`
  padding-bottom: 3px;

  @media screen and (max-width: 1024px) {
    padding-top: 25px;
  }
`;

export const ErrorWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1rem;
  height: 14px;

  img {
    width: 20px;
    height: 20px;
    margin-right: 7px;
  }
`;

export const ReserveButton = styled.button`
  width: fit-content;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.64px;
  min-width: 200px;
  min-height: 53px;
  cursor: pointer;
  border: none;
  background: ${variables.colorRed};
  color: ${variables.colorWhite};
  border-radius: 26px;
  margin-top: 32px;
  text-align: center;
  padding: 18px 10px;

  @media screen and (max-width: 1024px) {
    min-width: 160px;
    min-height: 45px;
    margin-top: 22px;
    padding: 13px 13px;
  }
`;

export const ValidationError = styled.div`
  color: #eb0000;
  font-size: 14px;
`;

export const StartChatButton = ReserveButton;

export const LoadingWrapper = styled.div`
  margin: 40px 0;
  width: 100%;
  height: 300px;

  @media screen and (max-width: 768px) {
    height: auto;
  }
`;
